export default __webpack_public_path__ + "static/media/vaino.8465914d.png";